import { createApp,createVNode,render,defineComponent } from 'vue';
import request from '@/utils/request';
import _localStorage from '@/utils/localStorage';
var localStorage = new _localStorage('qiuxiao2');
import popup from '@/components/popup';
import moment from 'moment';
const OSS = require('ali-oss');
import COS from 'cos-js-sdk-v5';
import {ElLoading} from 'element-plus';
import defaultAnchor from '@/assets/images/defaultAnchor.png';
let currStore;
import { newGuid, queryString } from './base-utils';

import { traceSpan } from "./otel-config";
export default {
	showLoading(text){
		const loading = ElLoading.service({
			lock: true,
			text: text||'Loading',
			background: 'rgba(255, 255, 255, 0.7)',
		});
		return loading;
	},
	newGuid,
	uniqueGuid(id,list){
		if(!id||!list||!list.length) return id;
		let has = list.find(e=>e == id);
		return has?this.uniqueGuid(this.newGuid(),list):id;
	},
	compare(x, y, props) {
		if (!x && !y) return true;
		if (!x || !y) return false;
		if (!props || !props.length) {
			props = this.unionArray(Object.keys(x), Object.keys(y));
		}
		for (var prop in props) {
			var propName = props[prop];
			if (x[propName] != y[propName]) return false;
		}
		return true;
	},
	//重试函数
	//fun：需要得到的保证
	reTry(fun, maxTimes, delay) {
		return new Promise((resolve, reject)=> {
			var attempt = ()=> {
				fun().then(resolve).catch((erro)=> {
					console.log(`还有 ${maxTimes} 次尝试`)
					if (0 == maxTimes) {
						reject(erro)
					} else {
						maxTimes--
						setTimeout(attempt, delay)
					}
				})
			}
			attempt()
		})
	},
	compareWithout(x, y, propsWithout) {
		if (!x && !y) return true;
		if (!x || !y) return false;
		var props = this.unionArray(Object.keys(x), Object.keys(y));
		if (propsWithout || propsWithout.length) {
			props = this.exceptArray(props, propsWithout);
		}
		for (var prop in props) {
			var propName = props[prop];
			if (x[propName] != y[propName]) return false;
		}
		return true;
	},
	//交集
	intersectArray(a, b) {
		return new Set([...a].filter(_a => b.indexOf(_a) >= 0));
	},
	//并集
	unionArray(a, b) {
		let tempArray = [];
		for (let i = 0; i < arguments.length; i++) {
			tempArray.push(...new Set(arguments[i]))
		}
		return [...new Set(tempArray)]
	},

	//差集
	exceptArray(a, b) {
		return a.filter(items => b.indexOf(items) == -1);
	},
	// 过滤非数字
	filterNonNumeric(num){
		return String(num).match(/[\d]/g,'').map(e=>e).join('');
	},
	//交集
	// intersectArray(a, b){
	//   return new Set([...a].filter(x => b.has(x)));
	// },
	getWindowID(){
		// debugger
		var u = navigator.userAgent;
		if(u){
		var us = u.split(',');
		var uaObj = {};
		us.forEach(ui=>{
			var uis = ui.split('=');
			if(uis.length==2){
			uaObj[uis[0].trim()] = uis[1];
			}
		})
		return uaObj.windowID||null;
		}
	},
	isPwaWindow(){
		if(typeof window === 'undefined') return false;
		let inStandalone = false;
		try{
			inStandalone = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
		}catch(err){}
		return !!(
			inStandalone
			|| window.navigator.standalone === true
			|| /^android-app:\/\//.test(document.referrer || '')
			|| /(?:^|[?&])pwa=true(?:&|$)/.test(window.location.search || '')
		);
	},
	openAppLinkTarget(){
		return this.isPwaWindow() ? '_self' : '_blank';
	},
	openAppRoute(router, routeLocation, target){
		if(!router || !routeLocation) return;
		if(this.isPwaWindow()){
			return router.push(routeLocation);
		}
		const resolved = router.resolve(routeLocation);
		return window.open(resolved.href || resolved.path, target || '_blank');
	},
	windowReload(confirm){
		var _window = window;
		if(confirm){
		this.$confirm('是否刷新本窗口?', '提示', {
			confirmButtonText: '刷新',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			document.location.reload();
			// _window.document.location.reload();
		})
		}else{
		document.location.reload();
		// _window.document.location.reload();
		}
	},
	// ImageParameterSplicing(value,size,df,ignorePicPro){ //图片路径过滤
	//     if(!value) return df?df:'';
	// 	let querystring, styleName='', isPicPro = !ignorePicPro && value.indexOf('picPro=1')>-1;
	// 	if(/^blob:/.test(value))return value;
	// 	let supportDomains = [
	// 		'res.mydomain.co', 
	// 		'h5static.mydomain.co', 
	// 		'611-little-fans.oss-cn-shenzhen.aliyuncs.com', 
	// 		'res.611res.com',
	// 	];
	// 	if (supportDomains.some(domain=>String(value).indexOf(domain)>-1)) {
	// 		if(isPicPro)styleName = 'style/t_400_600_limit';
	// 		else if(typeof(size) == "string")styleName = size;
	// 		else styleName = setParameterSplicing(size);
	// 		querystring = (value.split('?')[1]||"").split('&').filter(qsPair=>qsPair.split('=')[0].toLowerCase()!='x-oss-process');
	// 		value = value.split('?')[0];
	// 		querystring.push(`x-oss-process=${styleName}`);
	// 		return value + "?" + querystring.join("&");
	// 	}else{
	// 		return value;
	// 	}
	// },
	ImageParameterSplicing(value,size,df,ignorePicPro){
		if(!value) return df?df:'';
		let querystring, styleName='', isPicPro = !ignorePicPro && value.indexOf('picPro=1')>-1;
		if(/^blob:/.test(value))return value;
		let supportDomains = [
			'ap-guangzhou.myqcloud.com', 
			'ap-hongkong.myqcloud.com'
		];
		let supportResStyleDomains = localStorage.getItem('supportResStyleDomains');
		if(supportResStyleDomains){
			try{
				supportResStyleDomains = JSON.parse(supportResStyleDomains);
			}catch(err){
				console.log('解析supportResStyleDomains出现异常',err);
				supportResStyleDomains = [];
			}
			supportResStyleDomains.filter(e=>!supportDomains.find(s=>s == e)).forEach(e=>supportDomains.push(e));
		}
		let spliceArr = [32,64,100,200,300,400,600,800,1000,2000];
		if (supportDomains.some(domain=>String(value).indexOf(domain)>-1)) {
			querystring = (value.split('?')[1]||"").split('&');
			value = value.split('?')[0];
			let imageMogr = '';
			let has = spliceArr.find((e,i,self)=>e <= size && self[i+1]?self[i+1]>size:true);
			if(has){
				imageMogr = `imageMogr2/thumbnail/${has}x${has}`;
			}
			if(size&&spliceArr.every(e=>e<size)){
				imageMogr = 'imageMogr2/thumbnail/2000x2000';
			}
			imageMogr&&querystring.push(imageMogr);
			
			return value + "?" + querystring.join("&");
		}else{
			return value;
		}
	},
	isNumber(obj) {
		return obj === +obj
	},
	toDecimal(x, precision) {
		var f = parseFloat(x);
		var pre = parseInt(Math.pow(10, precision));
		if (isNaN(f)) {
			return;
		}
		f = Math.round(x * pre) / pre;
		return f;
	},
	/*
	 * 参数说明：
	 * number：要格式化的数字
	 * decimals：保留几位小数
	 * dec_point：小数点符号
	 * thousands_sep：千分位符号
	 * */
	toDecimalFormat(number, decimals, dec_point, thousands_sep) {
		number = (number + '').replace(/[^0-9+-Ee.]/g, '');
		var n = !isFinite(+number) ? 0 : +number,
			prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
			sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
			dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
			s = '',
			toFixedFix = function(n, prec) {
				// var k = Math.pow(10, prec);
				// return '' + Math.ceil(n * k) / k;
				return n.toFixed(prec);
			};

		s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
		var re = /(-?\d+)(\d{3})/;
		while (re.test(s[0])) {
			s[0] = s[0].replace(re, "$1" + sep + "$2");
		}

		if ((s[1] || '').length < prec) {
			s[1] = s[1] || '';
			s[1] += new Array(prec - s[1].length + 1).join('0');
		}
		return s.join(dec);
	},
	// 处理千分符
	thousandthMark(numstr,Symbolstr=','){
		numstr = numstr==undefined?'':numstr.toString();
		let sumArr = numstr.split('.');
		sumArr[0] = sumArr[0].replace(/(\d)(?=(?:\d{3})+$)/g,'$1'+Symbolstr)
		return sumArr.join('.');
	},
	deepClone() {
		// 定义一个变量
		let result, source;
		if (arguments.length == 0) return {};
		else if (arguments.length == 1) {
			source = arguments[0]
		} else if (arguments.length == 2) {
			result = arguments[0];
			source = arguments[1]
		} else {
			debugger;
			arguments.reduceRight((target, source) => this.deepClone(target, source))
		}

		// 如果当前需要深拷贝的是一个对象的话
		if (typeof source === 'object') {
			// 如果是一个数组的话
			if (Array.isArray(source)) {
				result = result || []; // 将result赋值为一个数组，并且执行遍历
				result.splice(0, result.length)
				for (let i in source) {
					// 递归克隆数组中的每一项
					result.push(this.deepClone(source[i]))
				}
				// 判断如果当前的值是null的话；直接赋值为null
			} else if (source === null) {
				result = null;
				// 判断如果当前的值是一个RegExp对象的话，直接赋值
			} else if (source.constructor === RegExp) {
				result = result || source;
			} else {
				// 否则是普通对象，直接for in循环，递归赋值对象的所有值
				result = result || {};
				for (let i in source) {
					result[i] = this.deepClone(result[i], source[i]);
				}
			}
			// 如果不是对象的话，就是基本数据类型，那么直接赋值
		} else {
			result = source;
		}
		// 返回最终结果
		return result;
	},
	queryString,
	// 区间随机数
	intervalRandom(min,max){
		let temp;
		if(min>max){
			temp=max;max=min;min=temp;
		}
		return Math.floor(Math.random() * (max - min) ) + min;
	},
	// 限制文本字节长度
	limitByteLength(value, byteLength,symbolLen=2) {
		var newvalue = value.replace(/[^\x00-\xff]/g, new Array(symbolLen).fill("*").join(''));
		var length = newvalue.length;
		//当填写的字节数小于设置的字节数
		if (length * 1 <= byteLength * 1) {
			return value;
		}
		var limitDate = newvalue.substr(0, byteLength);
		var count = 0;
		var limitvalue = "";
		for (var i = 0; i < limitDate.length; i++) {
			var flat = limitDate.substr(i, 1);
			if (flat == "*") {
				count++;
			}
		}
		var size = 0;
		var istar = newvalue.substr(byteLength * 1 - 1, 1); //校验点是否为“×”
		//if 基点是×; 判断在基点内有×为偶数还是奇数
		if (count % 2 == 0) {
			//当为偶数时
			size = count / 2 + (byteLength * 1 - count);
			limitvalue = value.substr(0, size);
		} else {
			//当为奇数时
			size = (count - 1) / 2 + (byteLength * 1 - count);
			limitvalue = value.substr(0, size);
		}
		return limitvalue;
	},
	/** 获取比赛状态
	 * @param {sportType} 体育类型
	 * @param {status} 比赛状态枚举
	 * @param {quarters} 篮球的共有节数
	 */
	getMatchState(sportType, status, quarters){
		const t = window.__i18n?.global?.t;
		let matchState=[];
		let statusArr=[{type:0,data:this.$constant.MatchState},{type:1,data:this.$constant.getBtbMatchState}];//预设各种体育类型的比赛状态
		statusArr.push(...[2,3,4].map(type=>{
			return {
				type,data:this.$constant.otherBallMatchState
			}
		}));
		let stateObj=statusArr.find(e=>e.type==sportType);
		if(stateObj)matchState=stateObj.data;
		else throw Error(`找不到对应的体育类型 "${sportType}" ，请检查体育类型是否正确`);
		let state=matchState.find(e=>e.value==status);
		let label=t ? t(state.label) : state.label;		
		if(sportType==0){ //足球
			// label = t ? t(state.label) : state.label;
		}else if(sportType==1){ //篮球
			switch(quarters){
				case 1://共有节数1
					if(status==1){
						label = '进行中';
					}else if(status==2){
						label = '常规时间结束';
					}
				break;
				case 2://共有节数2
					if(status==1){
						label = '上半场';
					}else if(status==2){
						label = '上半场结束';
					}else if(status==3){
						label = '下半场';
					}
					else if(status==4){
						label = '下半场结束';
					}
				break;
			}
		}else if(sportType==2){ //羽毛球
	
		}else if(sportType==3){ //乒乓球
	
		}else if(sportType==4){ //排球
	
		}
		return label;
	},
	handlerNumbers(value){ //数量转换显示
	    if(value || value==0){
	        if(value==0){
	            return value;
	        }
	        if(value>=10000){
	            // let toF=(value/10000).toFixed(9);  //四舍五入的数值比app少1
	            let toF=(value/10000).toFixed(1);
	            let wvalue = toF.split('.')[0];
	            let remainder = toF.split('.')[1];
	            if (remainder) {
	                value = wvalue +'.'+ remainder.substr(0,1) + 'w';
	                return value;
	            } else {
	                return wvalue + "w"
	            }
	        }else{
				return value.toString().replace(/(\d)(?=(?:\d{3})+$)/g,'$1,');
			}
	    }
	},
	// 获取球衣颜色
	getClothesColor: function(index) {
		const ClothesColor = this.$constant.ClothesColor.map(e=>e.color);
		return ClothesColor[index];
	},
	getExt(relUrl){
		if(!relUrl)return null;
		relUrl=relUrl.toString().replace(/^\//,'');
		return 'https://h5static.mydomain.com/qiuxiao2/ext/'+relUrl;
	},
	montageResco(path){
		if(path==undefined)throw Error('The '+path+' is illegal');
		return 'https://res.mydomain.co/'+path;
	},
	localStorageGetItem(key){
		let result = null;
		if(key==undefined)throw new Error('缺少必要参数key');
		else if(!key && typeof key == 'string')return result;
		let item = localStorage.getItem(key);
		if(/^{.*}$/.test(item)){
			try{
				result = JSON.parse(item)
			}catch(e){
				console.error(e);
			}
		}
		return result;
	},
	_copyText(text){
		return new Promise((resolve,reject)=>{
			let not = ['',undefined,null];
			if(not.indexOf(text)>-1)return reject('没有要复制的内容');
			try{
				let input = document.createElement('input');
				input.value = text;
				document.body.appendChild(input);
				input.select();
				document.execCommand("Copy");
				input.style.display = 'none';
				input.remove();
				resolve('复制成功！');
			}catch(e){
				reject(e)
			}
		})
	},
	// 获得promise的状态
	decidePromiseState(promise) {
		const PROMISE_STATE = {
			PENDING: 'pending',
			FULFILLED: 'fulfilled',
			REJECTED: 'rejected'
		}
		const t = {};
		return Promise.race([promise, t]).then(v => {
			return (v === t) ? PROMISE_STATE.PENDING : PROMISE_STATE.FULFILLED
		}).catch(() => PROMISE_STATE.REJECTED);
	},
	// 根据图片路径获取base64编码
	getUrlBase64(url,ext='png',width,height){
		return new Promise((resolve,reject)=>{
			let dataURL='';
			let c=document.createElement("canvas");
			let cxt=c.getContext('2d');
			let img = new Image();
			img.crossOrigin = 'Anonymous';
			img.src=url;
			if(!this.isNumber(width))width = img.width;
			if(!this.isNumber(height))height = img.height;
			img.onload=(e)=>{
				c.width=width;
				c.height=height;
				cxt.drawImage(img,0,0,width,height);
				dataURL=c.toDataURL('image/'+ext);
				c=null;
				// console.log(dataURL)
				resolve(dataURL);
			}
			img.onerror=()=>{
				resolve('');
			}
		})
	},
	awaitTime(time,cb,opt={}){
		return new Promise((resolve,reject)=>{
			try{
				opt.timer = setTimeout(()=>{
					cb&&cb();
					resolve();
				},time)
				setTimeout(()=>reject('退出了awaitTime'),time);
			}catch(err){
				reject(err);
			}
		}).catch(err=>{});
	},
	//节流函数
	throttle(fun, delay, time) {
		var timeout,
			startTime = new Date();
		return function () {
			var context = this,
				args = arguments,
				curTime = new Date();
			clearTimeout(timeout);
			// 如果达到了规定的触发时间间隔，触发 handler
			if (curTime - startTime >= time) {
				fun.apply(context, args);
				startTime = curTime;
				// 没达到触发间隔，重新设定定时器
			} else {
				timeout = setTimeout(function () {
					fun.apply(context, args);
				}, delay);
			}
		}
	},
	// 防抖函数
	debounce(callback, delay = 300) {
		let timer;
		let lastExc = 0;
		return function() {
			let context = this; // 这边的 this 指向谁?
			let args = arguments; // arguments中存着e
			
			let callNow = ()=>{
				lastExc = new Date().getTime();
				callback.apply(context, args);
			}
			var nextExcDelay = lastExc + delay - new Date().getTime();
			if(timer) clearTimeout(timer);
			if (nextExcDelay > 0) {
				// console.log("发起等待：" + nextExcDelay);
				timer = setTimeout(() => {
					timer = null;
					callNow();
				}, nextExcDelay);
			}else{
				console.log("无等待任务，立即执行");
				callNow();
			}
		}
	},
	StartUpObj(){
		return new Promise((resolve, reject) => {
			request({
				url:'/StartUp',
				method:'post',
				notips:true,
			}).then(res => {
				// traceSpan(res, "startup err", (span)=>{
				// 	span.setAttribute("test", 0);
				// 	span.setAttributes({
				// 		"test.1": "1",
				// 		"test.2": "2",
				// 	})
				// 	span.addEvent("test.3", {"test.3.1": 31});
				// 	span.addEvent("test.4", {"test.4.1": 41, "test.4.2": 41});
				// })
				// console.log('StartUp',res)
				if(res.data?.code == 200){
					// var appDomains = res.data.data.safeDomains.filter(e=>e).map(e=>{
					// 	let a = e.split('//');
					// 	if(a.length==1)
					// 		return a[0];
					// 	else 
					// 		return a[1];
					// });
					// if(appDomains){
					// 	localStorage.setItem('apiDomains',JSON.stringify(appDomains.map(domain=>Object({domain}))));
					// }
					// debugger;
					request.domain.updateList(res.data.data.appDomains);
					request.domain.updateReadOnlyApis(['newapi', 'oldapi']);
					// request.domain.updateReadOnlyApis(['newapi', 'oldapi']);
					// if(process.env.NODE_ENV == 'production'){
						// 在应用初始化前执行跳转检查
						// this.handleMobileRedirect(res.data.data.safeDomains);//不在前端跳转了
					// }
					resolve(res);
				}else{
					reject();
				}
			}).catch(err=>{
				reject(err);
			})
		})
	},
	loadImage(url){
		return new Promise((resolve,reject)=>{
			if(url){
				const image = new Image();
				image.src = url;
				image.onload = (e)=>{
					resolve(e);
				}
				image.error = (err)=>{
					reject(err)
				}
			}else{
				reject('url-err:'+url)
			}
		})
	},
	/**
	 * 获取登录信息
	 */
	getLoginInfo () {
		var token = localStorage.getItem('token');
		return request({
			timeout: 10000,
			method: 'post',
			url: 'Member/CurrentUser',
			data:{token}
		})
	},
	getUserInfo(store){
		return new Promise((resolve,reject)=>{
			request({
				url: "UserInfo",
				method: "post",
				notips:true,
			}).then(res => {
				if (res?.data?.code==200) {
					store&&store.action.user.updateUser(res.data.data);
					resolve(res.data.data);
				}else{
					reject(res?.data?.msg);
				}
			}).catch((err) => {
				console.log(err)
				reject(err);
			})
		})
	},
	saveFile(blob,fileName){
		return new Promise((resolve,reject)=>{
			try {
				const a = document.createElement('a');
				document.body.append(a);
				a.style.display = 'none';
				if(typeof blob == 'string'){
					a.href = blob;
				}else{
					a.href = window.URL.createObjectURL(blob);
				}
				if(fileName)a.download = fileName.replace(/[\/\\:*?"<>|]/g, '_');
				console.log('fileName',fileName);
				a.rel = 'noopener noreferrer';
				a.click();
				// 清理资源（延迟执行，避免点击未完成就撤销）
				setTimeout(() => {
					if (typeof blob !== 'string') {
						window.URL.revokeObjectURL(a.href);
					}
					document.body.removeChild(a);
					resolve();
				}, 100);
			} catch (error) {
				// 兜底清理资源
				document.body.removeChild(a);
				if (typeof blob !== 'string' && a.href) {
					window.URL.revokeObjectURL(a.href);
				}
				reject(error);
			}
		})
	},
	/**
	 * 格式化文件大小（字节转易读单位）
	 * @param {number} size - 文件大小（字节数，如25600）
	 * @returns {string} 格式化后的大小字符串（如"25.00 KB"）
	 */
	formatFileSize(size) {
		// 边界处理：非数字/负数返回0 B
		if (typeof size !== 'number' || size < 0) {
			return '0 B';
		}
		
		// 单位换算常量（1KB = 1024B，1MB = 1024KB，1GB = 1024MB）
		const units = [
			{ limit: 1024, unit: 'B' },    // 小于1K
			{ limit: 1024 * 1024, unit: 'KB' }, // 1K ~ 1M
			{ limit: 1024 * 1024 * 1024, unit: 'MB' }, // 1M ~ 1G
			{ limit: Infinity, unit: 'GB' }  // 大于等于1G
		];
		
		// 匹配对应的单位
		for (const { limit, unit } of units) {
			if (size < limit) {
			// 计算换算后的值（保留2位小数）
			let convertedSize = size;
			if (unit === 'KB') {
				convertedSize = size / 1024;
			} else if (unit === 'MB') {
				convertedSize = size / (1024 * 1024);
			} else if (unit === 'GB') {
				convertedSize = size / (1024 * 1024 * 1024);
			}
			// 格式化：去掉末尾的0和小数点（如25.00 → 25，1.20 → 1.2）
			return `${convertedSize.toFixed(2).replace(/\.00$|(\.\d*[1-9])0+$/, '$1')} ${unit}`;
			}
		}
		
		// 兜底返回（理论上不会执行）
		return '0 B';
	},
	//加载图片方法
	/**
		@param {String} target 元素目标
		@param {String} rul 图片的地址
		@param {Number} reloadTime 重试的等待时间（不传或传0即为不重试）
	 **/
	tryloadImg(target,url,reloadTime){
		if(!url)return;
		let random = this.intervalRandom(1000,9999),
			time = (+new Date()).toString().substr(-6);
		let _url = url.split('?')[0];
		let params = url.split('?')[1];
		let paramsArr = [];
		if(params){//如果存在参数则将参数取出来
			paramsArr = params.split('&').map(e=>{
				let key = e.split('=')[0];
				let val = e.split('=')[1];
				return {key,val}
			})
		}
		let has = paramsArr.find(e=>e.key == 'try');
		if(has){
			has.val = `${time}${random}`;
		}else{
			paramsArr.push({
				key:'try',
				val:`${time}${random}`,
			})
		}
		url = `${_url}?${paramsArr.map(e=>e.key + '=' + e.val).join('&')}`;
		const img = new Image();
		img.src = url;
		img.onload = ()=>{
			target.src = url;
		}
		img.onerror = ()=>{ //加载失败n秒后重试
			reloadTime&&this.awaitTime(reloadTime,()=>this.tryloadImg(target,url,reloadTime));
		}
	},
	// 设置页面滚动
	scrollTo(x=0,y=0){
		let currentY = window.scrollY;
		let i = window.scrollY;
		let scrollToInterval = setInterval(()=>{
			if(y>currentY){
				let step = (y-i) / 16 / 1.1;//计算步长，得到先快后慢的刹车效果
				i=parseInt(i + step);
				window.scrollTo(x,i);
				// console.log('向下↓',"当前位置：",i,"目标位置：",y);
				if(i>=(y-76)){//减去76导航头的高度
					clearInterval(scrollToInterval);
					scrollToInterval=null;
				}
			}else{
				i=parseInt(i/1.1);//先快后慢的刹车效果
				window.scrollTo(x,i);
				// console.log('向上↑',"当前位置：",i,"目标位置：",y);
				if(i<=0||i<=y){
					clearInterval(scrollToInterval);
					scrollToInterval=null;
				}
			}
		},20)
	},
	// 检查是否存在自定义的图片预览窗口
	checkHasPreviewImage(){
		let result = false;
		let body = document.querySelector('body');
		if(body){
			let has = [...body.children].find(e=>/.*previewImage.*/.test(e.className));//因为只查body下的第一层子元素，所以这里用find方法查询
			result = !!has;
		}
		return result;
	},
	tryIt(callback){
		return new Promise((resolve,reject)=>{
			try {
				if(typeof callback == 'function'){
					callback();
					resolve();
				}else if(typeof callback != 'function'){
					reject('callback:is not a funcction');
				}else if(callback == undefined){
					reject('callback:is undefined');
				}else{
					reject('callback:Unknown');
				}
			} catch (error) {
				reject(error);
			}
		})
	},
	loadFont(name,url){
		// 创建一个新的FontFace对象
		const fontFace = new FontFace(name, `url(${url})`, {
			weight: 'normal',
			style: 'normal',
			// 其他字体属性
		});
		// 加载字体
		return fontFace.load().then(() => {
			// 字体加载完成后，将其添加到document
			document.fonts.add(fontFace);
		}).catch(error => {
			console.error('Font loading error:', error);
		});
	},
	/** 遍历多维对象数组
	* @param {string} childrenKey 子代元素的key
	* @param {string} key 数组的唯一关键字(如，id)
	*/
	multidimensionalObjectArray(){
		return class multidimensionalObjectArray {
			constructor(obj,opt={}){
				if(typeof obj != 'object')console.error('请检查参数，首位参数应是数组或对象！');
				let {childrenKey,key} = opt;
				this.obj=obj;
				this.childrenKey='children';
				if(childrenKey)this.childrenKey = childrenKey;
				this.key='id';
				if(key)this.key = key;
			}
			forEach(callback) {
				return this._each('forEach',{callback});
			}
			find(callback){
				return this._each('find',{callback});
			}
			_each(mode,{callback}){
				let result = (function eachData(obj,key,level,parent){
					if(level==undefined)level=0;
					else level++;
					if(typeof obj != 'object')return;
					for (var i in obj) {
						let item = obj[i];
						Object.assign(item,{_sourceIndex:item._index?item._index:i});
						Object.assign(item,{_index:i});
						let [path1,path2] = [item[key],item[key]];
						if(/\./.test(key)){
							let keyArr = key.split('.');
							path1 = item[keyArr[0]];
							path2 = keyArr[1]?(path1?path1[keyArr[1]]:path1):path1;
						}
						if(mode=='find'){
							Object.assign(item,{_level:level})
							let has;
							try{
								has = callback && callback(item,i,level,parent);
							}catch(err){
								throw new Error(err);
							}
							if(path1 && path2 && has){
								return item;
							}else{
								let _parent = Object.assign({},item);
								// Reflect.deleteProperty(_parent, 'list');
								if(parent){
									_parent = Object.assign({},_parent,{_parent:parent});
								}
								let result = item && eachData.call(this,item[this.childrenKey],key,level,_parent);
								if(result){
									return result;
								}
							}
						}else if(mode=='forEach'){
							let _parent = Object.assign({},item);
							// Reflect.deleteProperty(_parent, 'list');
							if(parent){
								_parent = Object.assign({},_parent,{_parent:parent});
							}
							try{
								callback&&callback(item,i,level,_parent);
							}catch(err){
								throw new Error(err);
							}
							eachData.call(this,item[this.childrenKey],key,level,_parent);
						}
					}
				}).call(this,this.obj,this.key);
				return result;
			}
		}
	},
	// 计算两点之间的距离（单位：公里）
	calculateDistance(lat1, lon1, lat2, lon2) {
		const R = 6371; // 地球半径，单位为公里
		const dLat = (lat2 - lat1) * Math.PI / 180;
		const dLon = (lon2 - lon1) * Math.PI / 180;
		const a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
			Math.sin(dLon / 2) * Math.sin(dLon / 2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		return R * c;
	},
	/** 根据经纬度获取最近的城市
	* @param {object} latAndLon 传入的经纬度
	* @param {object} opt 配置项
	* @param {string} opt.latKeyName|opt.lonKeyName 经纬度的别称
	* @param {array} opt.citylist 存在经纬度的城市列表
	* @param {object} opt.iteratorOpt 遍历器的配置
	* 使用举例：↓
		let city = this.latAnIonGetLocation({latitude:40.31602,longitude:116.63168},{
			latKeyName:'lat',
			lonKeyName:'lng',
			cityList:[],
			iteratorOpt:{
				childrenKey:'list',
			}
		})
		console.log('获得的城市：',city);
	*/
	latAnIonGetLocation(latAndLon,opt={}){
		let {latitude,longitude} = latAndLon;
		let {latKeyName,lonKeyName,cityList,iteratorOpt} = opt;
		latKeyName = latKeyName||'latitude';
		lonKeyName = lonKeyName||'longitude';
		let [closest,target] = [null,null];
		let iterator = this.multidimensionalObjectArray();
		let ObjectArray = new iterator(cityList,iteratorOpt||{});
		ObjectArray.forEach(e=>{
			if(closest == null){
				closest = this.calculateDistance(latitude,longitude, e[latKeyName],e[lonKeyName]);
				target = e;
			}else{
				let r = this.calculateDistance(latitude,longitude, e[latKeyName],e[lonKeyName]);
				if(r < closest){
					closest = r;
					target = e;
				}
			}
		})
		return target;
	},
	// 拿到城市列表
	getCitysData() {
		let GetCitysData = ()=>{
			return new Promise((resolve,reject)=>{
				request({
					url: 'Competition/GetCitysData',
					method: 'get'
				}).then(({ data }) => {
					if (data && data.success) {
						resolve(data.data);
					}else{
						reject(data.message);
					}
				}).catch(err=>{
					reject(err);
				});
			})
		}
		return new Promise((resolve,reject)=>{
			let getSearchParams = ()=>{
				return location.search.substring(1).split('&').filter(e=>e).map(kvStr=>{
					var kv = kvStr.split('='); 
					return {key:kv[0], val:kv.length==2?kv[1]:null}
				});
			}
			var qs = getSearchParams();
			var verItem = qs.find(kv=>kv.key=="ver");
			let citysDataConfig = localStorage.getItem('citysDataConfig');
			try{
				citysDataConfig = JSON.parse(citysDataConfig);
			}catch(err){
				// console.log('解析失败则跳过');
				// reject(err);
			}
			// 如果本地存在城市列表且版本号一致，则直接使用本地数据
			if(citysDataConfig && citysDataConfig.ver == (verItem&&verItem.val)){
				resolve(citysDataConfig.data);
			}else{
				// console.log('执行GetCitysData方法');
				GetCitysData().then((data)=>{
					let citysDataConfig = {
						ver:verItem?verItem.val:'v1',
						data
					}
					localStorage.setItem('citysDataConfig',JSON.stringify(citysDataConfig));
					resolve(data);
				}).catch(err=>{
					reject(err);
				})
			}
		})
	},
	// 获取定位（腾讯位置服务）
	geolocation(){
		return new Promise(async(resolve,reject)=>{
			let store = null;
			await import('@/store').then(({ useStore })=>{
				store = useStore();
			});
			let location = store && store.state.location;
			if(location && Object.keys(location).length){
				return resolve(location);
			}
			const locaKey="";//获取定位的Key
			var geolocation = {}
			try{
				geolocation = new qq.maps.Geolocation(locaKey, "web");
			}catch(err){
				reject(err);
			}
			let showPosition=(position)=> {
				store && store.action.location.setLocation(position);
				resolve(position);
			}
			let showErr=()=> {
				reject('定位失败');
			}
			geolocation.getIpLocation&&geolocation.getIpLocation(showPosition, showErr);
		}).catch(err=>{
			console.log(err);
		})
	},
	splitArray(arr, size = 30){
		const res = []
		for (let i = 0; i < arr.length; i += size) {
			res.push(arr.slice(i, i + size))
		}
		return res
	},
	clearObject(obj) {
		Object.keys(obj).forEach((key)=>delete obj[key]);
	},
	objectToParamStr(obj){
		return Object.keys(obj).map(k=>`${k}=${obj[k]}`).join('&');
	},
	findDom(target, dom, opt={}){
		let {upOrDown,limitLevel} = opt;
		if(upOrDown == undefined)upOrDown = false;
		if(limitLevel == undefined)limitLevel = 10;
		dom = dom ? dom : document;
		if (upOrDown) { //向上找
			if (!limitLevel) limitLevel = 10;
			let count = 0;
			return (function findParentElement(_dom) {
				let parent = _dom&&_dom.parentElement
				let has = parent&&parent.querySelector(target);
				if (has) {
					return has;
				} else {
					count++;
					if (count >= limitLevel) { //达到限制的层数
						count = 0;
						return; //停止递归
					}
					return findParentElement(parent); //向上递归查找元素
				}
			})(dom)
		} else { //向下找
			let hasTarget = dom && dom.querySelector(target);
			return hasTarget;
		}
	},
	getRequestHeaders(){
		let requestHeaders = {};
		let token = (localStorage.getItem('token')) || '';
		if (token) requestHeaders.accessToken = token;
		let agentToken = this.queryString('agentToken', true);
		agentToken ? requestHeaders.agentToken = agentToken : '';//代理的token
		let deviceid = localStorage.getItem('DeviceID');
		try{
			if(/^\{.*\}$/.test(deviceid)){
				deviceid = JSON.parse(deviceid).DeviceID;
			}
		}catch(e){
			deviceid = '';
			console.log('处理DeviceID出错',e)
		}
		if(deviceid){
			requestHeaders.deviceid = deviceid;
		}else{
			requestHeaders.deviceid = 'web';
		}
		requestHeaders.source = '5';
		requestHeaders.lytime = moment().format('yyyy-MM-DD HH:mm:ss');
		requestHeaders.versions = '1.0';
		return requestHeaders;
	},
	//拿到城市id对应的名称
	getCityName(cityID,cityList) {
		let iterator = this.multidimensionalObjectArray();
		let objectArray = new iterator(cityList);
		let has = objectArray.find(e=>e.id == cityID);
		let result = has?has.cities:'';
		return result;
	},
	// 城市区域列表 如[1,2,3]
	getCityAreas(areaID, cityList){
		let iterator = this.multidimensionalObjectArray();
		let ObjectArray = new iterator(cityList);
		let areasArr = [];
		let has = ObjectArray.find((e,i,level,parent)=>{
			let res = e.id == areaID;
			if(res){
				let parentArr = new iterator(parent,{childrenKey:'_parent'});
				parentArr.forEach((e,i)=>{
					if(e.id){
						areasArr.push(e.id);
					}else{
						if(i=='id')areasArr.push(e);
					}
				})
				areasArr.reverse().push(e.id);
			}
			return res;
		});
		return areasArr;
	},
	confirmBeforeClose(action, instance, done){
		if (action === 'confirm') {
			instance.onclick = function() {
				let type = window.event.type;
				if (type !== 'keydown') {
					done();
				}
			}()
		} else {
			done();
		}
	},
	formatDateTime(val, fmt) {
		if (!val) return null;
		if (typeof(val) == "string") {
			val = val.replace("-", "/").replace("-", "/");
			var tick = Date.parse(val);
			val = new Date(tick);
		}
		let ret;
		let opt = {
			"Y+": val.getFullYear().toString(), // 年
			"m+": (val.getMonth() + 1).toString(), // 月
			"d+": val.getDate().toString(), // 日
			"H+": val.getHours().toString(), // 时
			"M+": val.getMinutes().toString(), // 分
			"S+": val.getSeconds().toString() // 秒
			// 有其他格式化字符需求可以继续添加，必须转化成字符串
		};
		for (let k in opt) {
			ret = new RegExp("(" + k + ")").exec(fmt);
			if (ret) {
				fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
			};
		};
		return fmt;
	},
	// 二次确认弹窗
	//在苹果的Safari浏览器中会消失弹窗——Safari会限制弹窗的行为，尤其是在某些特定的上下文中（如异步请求中）。这可能会导致 $prompt 弹窗无法正常显示。），则需要延迟400毫秒（动画时间300ms）；
	secondaryConfirm(time=400){
		return new Promise((resolve,reject)=>{
			this.$nextTick(()=>{
				this.awaitTime(time,()=>{
					this.$prompt(`此操作需要输入删除验证码：DEL`, '数据删除警告', {
						confirmButtonText: '删除',
						cancelButtonText: '我再想想',
						confirmButtonClass: 'confirmButtonClass',
						type: 'warning',
						showInput:true,
						inputPlaceholder:"在此输入删除验证码",
						inputPattern: /^DEL$/,
						inputErrorMessage:"无法确认您的删除操作！",
						closeOnClickModal:false
					}).then(()=>{
						resolve();
					}).catch(e=>{
						reject(e);
					})
				})
			})
		})
	},
	closeWindow(){
		window.close();
	},
	fullScreen(){
		// var doc = document.documentElement,
		// requestFunc = (doc.requestFullscreen || doc.webkitRequestFullScreen),
		// cancelFunc = (document.cancelFullScreen || document.webkitCancelFullScreen);
		// if(this.isFullScreen) {
		//   cancelFunc.call(document);
		//   this.isFullScreen = false;
		// }else{
		//   requestFunc.call(doc);
		//   this.isFullScreen = true;
		// }
		var isFullscreen = document.fullScreenElement//W3C
					||document.msFullscreenElement //IE
					||document.mozFullScreenElement //火狐
					||document.webkitFullscreenElement //谷歌
					||false;
		if(!isFullscreen){
			var el = document.documentElement;
			if (el.requestFullscreen) { 
				el.requestFullscreen(); 
			} else if (el.mozRequestFullScreen) { 
				el.mozRequestFullScreen(); 
			} else if (el.webkitRequestFullscreen) { 
				el.webkitRequestFullscreen(); 
			} else if (el.msRequestFullscreen) { 
				el.msRequestFullscreen(); 
			} 
			this.isFullScreen = true;
		}else{
			if (document.exitFullscreen) { 
				document.exitFullscreen(); 
			} else if (document.msExitFullscreen) { 
				document.msExitFullscreen(); 
			} else if (document.mozCancelFullScreen) { 
				document.mozCancelFullScreen(); 
			} else if (document.webkitCancelFullScreen) { 
				document.webkitCancelFullScreen(); 
			} 
			this.isFullScreen = false;
			window.resizeTo(1280, 720);
			window.moveTo((screen.availWidth - 1280) / 2, (screen.availHeight - 720) / 2);
		}
	},
	changeLanguage(lang) {
		this.$i18n.locale = lang; // 切换语言到lang（'en'或'zh'）
	},
	anchorAvatarErr(e){
		e.target.src = defaultAnchor;
	},
	addVisitRecord(_data){
		let data = Object.assign({},_data);
		// Object.keys(data).forEach(k=>{
		// 	if([null,undefined].some(s=>s == data[k]))delete data[k];
		// })
		return request({
			url:'AddVisitRecord',
			data,
			method:'post',
			notips:true,//报错不弹出提示
		}).catch(err=>{
			console.log('AddVisitRecord-上报异常',err);
		})
	},
	userActivityEvent(_data){
		let data = {
			code:null,
			paramId:null,//事件对象id
			taskProgressNum:null,//任务进度数 观看视频任务时传观看时间，单位：s）不传默认=1
			sharePlatform:null,//分享的平台，1：微博，2：微信，3：QQ ，4:微信朋友圈,5:QQ空间
			shareType:null,//分享的类型，1：资讯，2：圈子，3：比赛，4：阵容，5：app好友分享，6：活动分享，7赛事，8海报，9二维码
			shareTime:null,//分享时间
		};
		Object.assign(data,_data);
		// Object.keys(data).forEach(k=>{
		// 	if([null,undefined].some(s=>s == data[k]))delete data[k];
		// })
		return new Promise((resolve,reject)=>{
			request({
				url:'UserActivityEvent',
				data,
				method:'post',
				notips:true,//报错不弹出提示
			}).then(res=>{
				if(res&&res.data.code == 200){
					resolve(res.data);
				}else{
					reject(res.data.msg);
				}
			}).catch(err=>{
				reject(err);
			});
		}).catch(err=>{
			console.log('UserActivityEvent-上报异常',err);
		})
	},
	//广告的上报
	AdvEventCallback(data){
		request({
			url:'/AddVisitRecord',
			method:'post',
			data: data,
			notips: true,
		}).then(res => {
			// console.log('广告上报成功',res);
		}).catch(err=>{
			// console.log('广告上报失败',err);
		})
	},
	//广告点击公共方法
	adClick(item,programId){
		console.log('广告点击公共方法',item,programId)
		let data={}
		if(programId){
			data={
				actionType: "AdClick",
				contentId: item.id,
				programId: programId,
			}
		}else{
			data={
				actionType: "AdClick",
				contentId: item.id,
			}
		}
		this.AdvEventCallback(data)
	},
	//广告的展示
	AdvShowCallback(item,programId){
		let data={}
		if(programId){
			data={
				actionType: "AdView",
				contentId: item.id,
				programId: programId,
			}
		}else{
			data={
				actionType: "AdView",
				contentId: item.id,
			}
		}
		this.AdvEventCallback(data)
	},
	//图片广告加载完毕
	AdvImgLoadCallback(item,programId){	
		let data={}
		if(programId){
			data={
				actionType: "AdView",
				contentId: item.id,
				programId: programId,
			}
		}else{
			data={
				actionType: "AdView",
				contentId: item.id,
			}
		}
		this.AdvEventCallback(data)
	},
	
	isIpad(){
	  // 兼容新旧iPadOS
	  return (
	    /ipad/i.test(navigator.userAgent.toLowerCase())
	    || (navigator.platform === 'MacIntel' && 'ontouchstart' in window)
	    || window.matchMedia('(min-width: 768px) and (max-width: 1366px) and (pointer: coarse)').matches
	  );
	},
	isNotAppleDevice() {
		const ua = navigator.userAgent || '';
		// 匹配 iPhone / iPad / iPod / Macintosh
		const isApple = /(iPhone|iPad|iPod|Macintosh)/i.test(ua);
		return !isApple;
	},
	// 检测是否为移动设备
	isMobileDevice() {
		// 单独判断是否为iPad设备
		
	  // 检测用户代理是否包含移动设备特征
	  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	},
	// 处理移动设备跳转
	handleMobileRedirect(safeDomains) {
		if (this.isMobileDevice()) {
			var _safeDomains = safeDomains.map(d=>d.replace(RegExp('https{0,1}://'), ''));
			let mainDomain = _safeDomains[0];
			if( /^(www\.)/.test(window.location.hostname)){
				let hasDoMain = _safeDomains.find(e=>/^(m\.)/.test(e) && RegExp(location.hostname.replace(/^(www\.)/,'')).test(e));
				if(hasDoMain){
					mainDomain = hasDoMain;
				}
			}
			let pathname = window.location.pathname.toLocaleLowerCase();
			let routeContrast = [
				{webRoute:'/liveroomdetails',h5Route:'/match'},
				{webRoute:'/live',h5Route:'/live'},
				{webRoute:'/schedule',h5Route:'/matchList'},
				{webRoute:'/message/msg',h5Route:'/message'},
			];
			let has = routeContrast.find(e=>e.webRoute == pathname);
			if(has){
				pathname = has.h5Route;
			}else{
				pathname = '/';
			}
			// 构建完整的移动版URL
			const mobileUrl = `${window.location.protocol}//${mainDomain}${pathname}${window.location.search}`;
			// 跳转到移动版
			window.location.href = mobileUrl;
		}
	},
	async getSptData({sportType,buss_type,buss_id,buss_name,params}){
		let p;
		try{
			let _params = {t:Date.now()};
			params&&Object.assign(_params,params);
			_params = this.objectToParamStr(_params);
			if(!currStore){
				let { useStore } = await import('@/store');
				currStore = useStore();
			}
			if (!currStore.state.startUp.configData?.unstructuredSportDataHost){
				await this.awaitTime(500);
				return this.getSptData({ sportType, buss_type, buss_id, buss_name, params });
			}
			var lang = null;
			switch(this.$i18n.locale){
				case 'en':
					lang = 'en';
					break;
				case 'vi':
					lang = 'vi';
					break;
				default:
					lang = 'zh';
					break;
			}
			if(lang) buss_name = `${buss_name}.${lang}`;
			let url = currStore.state.startUp.configData.unstructuredSportDataHost + `/spt/data/${sportType}/${buss_type}/${buss_id}/${buss_name}.json?${_params}`;
			p = this.request({
				serv: 'custom',
				url,
				method: 'get',
				notips: true,
			}).then((res)=>{
				if (res == undefined){//访问远程资源404时，依然会进入then，这里手动抛出一个异常
					throw res;
				}
				return res;
			}).catch(err => {
				// 如果请求失败且设置了 lang，尝试去掉 lang 再请求一次
				if (lang && buss_name.endsWith(`.${lang}`)) {
					let noLangBussName = buss_name.substring(0, buss_name.lastIndexOf('.'));
					let retryUrl = currStore.state.startUp.configData.unstructuredSportDataHost + `/spt/data/${sportType}/${buss_type}/${buss_id}/${noLangBussName}.json?${_params}`;
					return this.request({
						serv: 'custom',
						url: retryUrl,
						method: 'get',
						notips: true,
					});
				}
				return err;
			});
		}catch(err){
			p = Promise.reject(err);
		}
		return p;
	},
	// 转义成实体字符
	escapeHtml(str,contrary){
		if(str==undefined)return;
		if(contrary){
			return str
				.replace(/\&amp;/g, '&')
				.replace(/\&lt;/g, '<')
				.replace(/\&gt;/g, '>')
				.replace(/\&quot;/g, '"')
				.replace(/\&#039;/g, '')
		}else{
			return str
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#039;')
		}
	},
	getLiveAdvertisingData(data){
		return new Promise((resolve,reject)=>{
			this.request({
				url:'LiveAdvertisingData',
				data,
				method:'post',
			}).then(({data})=>{
				if(data?.code == 200){
					resolve(data.data);
				}else{
					reject(data?.msg);
				}
			}).catch(err=>{
				reject(err);
			})
		})
	},
	//解析二进制
	parseRoleToIdentityFlagsList(role) {
		let identityFlagsList = [];
		let index = 0; // 从下标0开始

		while (role > 0) {
			if (role & 1) {
				// 检查最低位是否为1
				identityFlagsList.push(index); // 推入下标值
			}
			role >>= 1; // 右移一位
			index++; // 下标加1
		}
		return identityFlagsList;
	},
	parseUrl(href){
		const urlObj = {
			href,
			protocol: '',
			origin: '',
			host: '',
			hostname: '',
			port: '',
			pathname: '',
			search: '',
			hash: '',
			searchParams: {} // 解析后的查询参数对象
		};
		
		// 1. 拆分 hash（# 后面内容）
		const hashSplit = href.split('#');
		urlObj.hash = hashSplit[1] ? `#${hashSplit[1]}` : '';
		let urlWithoutHash = hashSplit[0];
		
		// 2. 拆分 search (? 后面内容)
		const searchSplit = urlWithoutHash.split('?');
		urlObj.search = searchSplit[1] ? `?${searchSplit[1]}` : '';
		const pathAndHost = searchSplit[0];
		
		// 3. 拆分协议 http:// https:// ftp:// 等
		const protocolReg = /^([a-zA-Z0-9]+:)?\/\//;
		let protocolMatch = pathAndHost.match(protocolReg);
		if (protocolMatch) {
			urlObj.protocol = protocolMatch[1] || '';
			// 去掉协议，剩余 host + path
			const hostPath = pathAndHost.slice(protocolMatch[0].length);
			// 拆分 host 和 pathname（第一个 / 分割）
			const slashIndex = hostPath.indexOf('/');
			if (slashIndex > -1) {
			urlObj.host = hostPath.slice(0, slashIndex);
			urlObj.pathname = hostPath.slice(slashIndex);
			} else {
			urlObj.host = hostPath;
			urlObj.pathname = '/';
			}
		} else {
			// 无协议，相对路径
			urlObj.pathname = pathAndHost || '/';
		}
		
		// 4. 拆分 hostname 和 port
		if (urlObj.host) {
			const portReg = /:(\d+)$/;
			const portMatch = urlObj.host.match(portReg);
			if (portMatch) {
			urlObj.port = portMatch[1];
			urlObj.hostname = urlObj.host.replace(portReg, '');
			} else {
			urlObj.hostname = urlObj.host;
			urlObj.port = '';
			}
		}
		
		// 5. 拼接 origin（协议 + host）
		urlObj.origin = urlObj.protocol ? `${urlObj.protocol}//${urlObj.host}` : '';
		
		// 6. 解析 search 查询参数到 searchParams
		if (urlObj.search) {
			const queryStr = urlObj.search.slice(1); // 去掉开头 ?
			const paramsArr = queryStr.split('&');
			paramsArr.forEach(item => {
			if (!item) return;
			const [key, val] = item.split('=');
			// 解码中文、特殊符号
			const decodeKey = decodeURIComponent(key);
			const decodeVal = decodeURIComponent(val ?? '');
			urlObj.searchParams[decodeKey] = decodeVal;
			});
		}
		
		return urlObj;
	},
	//
	showToast(content, delay = 3000,closeCallback){
		return new Promise((resolve,reject)=>{
			try{
				let config = {content, delay};
				destroy_popup.apply({type:'toast'});
				createElement_popup(config,'toast');
				setTimeout(()=>{
					closeCallback&&closeCallback();//执行关闭回调
				},delay)
				resolve();
			}catch(e){
				reject(e);
			}

		})
	},
	showModel(param){
		return new Promise((resolve,reject)=>{
			try{
				let config = {content:param};
				destroy_popup.apply({type:'model'});
				createElement_popup(config,'model');
				resolve();
			}catch(e){
				reject(e);
			}
		})
	},
	// 上传文件
	uploadFile(params,file){
		return new Promise((resolve, reject) => {
			if(true){//腾讯上传
				let requestParmas = {
					url:`TXAssumeRole`,
					data:{},
					method: "post"
				}
				if(!params.custom){
					if(!file)return reject('缺少file参数');
					let defalutParmas = ['extName'];
					let _params = {};
					defalutParmas.forEach(k=>{
						if(params[k]!=undefined){
							_params[k] = params[k];
						}
					})
					requestParmas.data = _params;
				}else{
					Object.assign(requestParmas,params.data);
				}
				this.request(requestParmas).then(({data}) => {
					if (data && data.success || data.code == 200) {
						// 初始化COS实例
						var cosInstance = new COS({
							getAuthorization: (options, callback) => {
								callback({
									TmpSecretId: data.data.accessKeyId,
									TmpSecretKey: data.data.accessKeySecret,
									SecurityToken: data.data.securityToken,
									ExpiredTime: moment(data.data.expiration).valueOf()/1000
								});
							}
						});
						// 执行COS上传
						cosInstance.putObject({
							Bucket: data.data.bucket,
							Region: data.data.region,
							Key: data.data.objectKey,
							Body: file,
							onProgress: (progressData) => {
								params.onProgress&&params.onProgress({
									percent: progressData.percent * 100
								});
							},
						}, (err) => {
							if (err) {
							// 	throw(new Error(`上传失败: ${err.Message || '未知错误'}`));
								console.log('腾讯上传-回调err：',err);
								reject(err);
							}else{
								console.log('腾讯上传-回调：',err);
								resolve(data.data.signUrl);
							}
						})
					}else{
						reject(data.message || data.msg);
					}
				}).catch(err=>{
					reject(err);
				})
			}else{//阿里上传
				let requestParmas = {
					url:`GetAssumeRole`,
					params:{},
				}
				if(!params.custom){
					if(!file)return reject('缺少file参数');
					let defalutParmas = ['iconType','dataId','sportType','extname'];
					let _params = {};
					defalutParmas.forEach(k=>{
						if(params[k]!=undefined){
							_params[k] = params[k];
						}
					})
					requestParmas.params = _params;
				}else{
					Object.assign(requestParmas,params.data);
				}
				this.request(requestParmas).then(({data}) => {
					if (data && data.success) {
						let res = data.data;
						const client = new OSS({
							region: res.assumeRole.region,
							accessKeyId: res.assumeRole.accessKeyId,
							accessKeySecret: res.assumeRole.accessKeySecret,
							Expiration: res.assumeRole.rxpiration,
							UseToken: res.assumeRole.useToken,
							bucket: res.assumeRole.bucket,
							stsToken: res.assumeRole.securityToken //加上这一行，问题解决
						});
						if(!params.custom){
							client.put(res.path, file).then((r1) => {
								let url = this.montageResco(res.path)
								resolve(url);
							}).catch(err=>{
								reject(err);
							})
						}else{
							let endIndex = res.path.lastIndexOf('.');
							let path = res.path.slice(0,endIndex);
							resolve({client,path});
						}
					}else{
						reject(data.message || data.msg);
					}
				}).catch(err=>{
					reject(err);
				})
			}
			
		})
	},
	showOpenMember(opt){
		this.$bus.emit('showOpenMember',opt);
	},
	back(){
		history.back()
	},
	parsingEmoticons(str,emojiListView) {
		var fn = (str,startPoint=0) => {
			if (!emojiListView.length) return str;
			let str1 = (str??'').toString().split('');
			let leftIndex = -1;
			let rightIndex = -1;
			let i = 0;
			if(startPoint>0){
				i = startPoint;
			}
			for (; i < str1.length; i++) {
				if (leftIndex == -1) {
					// debugger
					if (str1[i] == '[') leftIndex = i;
				} else if (rightIndex == -1) {
					if (str1[i] == ']') {
						rightIndex = i;
						let _str1 = str1.join('');
						let s = _str1.slice(leftIndex + 1, rightIndex);
						let has = emojiListView.find(e => e.key == s);
						let _leftIndex = leftIndex;
						if (has) {
							let res = `<img src="${has.url}" name="${has.key}" class="emoticons_item" >`;
							str1.splice(leftIndex, rightIndex - leftIndex + 1, res);
							startPoint = 0;
							leftIndex = -1;
						}else{
							startPoint = rightIndex + 1;
						}
						// debugger
						if (i < str1.length - 1 + (_leftIndex + rightIndex)) {
							return fn(str1.join(''),startPoint);
						}
						break;
					}
				}
			}
			return str1.join('');
		}
		return fn(str);
	},
	/**
	 * 将字符串中的超链接替换为a标签
	 * 适配场景：http/https开头、IP地址链接、无协议域名（www/非www）、带参数的链接
	 * @param {string} str - 包含链接的原始字符串
	 * @param {Object} options - 可选配置（target/_blank等）
	 * @returns {string} 替换后的字符串
	 */
	replaceLinkToATag(str, options = {}) {
		if (typeof str !== 'string') return str;
		
		// 核心正则：匹配所有常见链接格式
		const linkReg = /(https?:\/\/)?((\d{1,3}\.){3}\d{1,3}:\d{1,5}|([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(\/[^\s]*)?/g;
		
		// 默认配置：新窗口打开、添加noopener noreferrer安全属性
		const defaultOptions = {
			target: '_blank',
			rel: 'noopener noreferrer',
			...options
		};
		return str.replace(linkReg, (match) => {
			// 补全无协议链接的http://（避免a标签href无效）
			const href = match.replace(/&/g, '&amp;').startsWith('http') ? match : `http://${match}`;
			// 拼接a标签属性
			const attrs = Object.entries(defaultOptions)
			.map(([key, value]) => `${key}="${value}"`)
			.join(' ');
			// 返回完整a标签（链接文本与原始匹配内容一致）
			return `<a href="${encodeURI(href)}" ${attrs}>${match}</a>`;
		});
	},
}
let popupOpt = {
	showToastTimeout:null,
}
function createElement_popup(config, type){
	let props = {};
	if(type == 'toast'){
		props = {content:config.content, delay:config.delay,type};
	}else if(type == 'model'){
		props = {model:config.content,type};
	}
	// let app = createApp(popup,props);
	// console.log('app',app)
	const vnode = createVNode(popup, props);
	// Object.assign(app._context, appContext) // must use Object.assign on _context
	let appel = document.getElementById('app');
	let el = appel.children.length?appel.children[0]:appel;
	let hasPopup =  [...el.children].find(e=>e.name == 'popup');
	if(!hasPopup){
		let div = document.createElement('div');
		div.name = 'popup';
		el.appendChild(div);
	}
	let popupEl = el.children[el.children.length-1];
	let has = [...popupEl.children].find(e=>e.name == type);
	if(!has){
		let div = document.createElement('div');
		div.name = type;
		popupEl.appendChild(div);
	}
	let upEl = [...popupEl.children].find(e=>e.name == type);
	// app.mount(upEl);
	render(vnode, upEl);
	// console.log('vnode',vnode.component)
	vnode.component.exposed.destroyPop.value = destroy_popup.bind({type});
	type == 'toast'&&Object.keys(popupOpt).forEach(k=>{
		let target = popupOpt[k];
		if(target&&target!=vnode.component.exposed.target){
			clearTimeout(target);
		}
		popupOpt[k] = vnode.component.exposed[k];
	})
}
function destroy_popup(){
	let appel = document.getElementById('app');
	let el = appel.children.length?appel.children[0]:appel;
	let hasPopup =  [...el.children].find(e=>e.name == 'popup');
	if(!hasPopup){
		let div = document.createElement('div');
		div.name = 'popup';
		el.appendChild(div);
	}
	let popupEl = el.children[el.children.length-1];
	let has = [...popupEl.children].find(e=>e.name == this.type);
	if(!has){
		let div = document.createElement('div');
		div.name = this.type;
		popupEl.appendChild(div);
	}
	let upEl = [...popupEl.children].find(e=>e.name == this.type);
	render(null, upEl);
}

function setParameterSplicing(size){
	if (size <= 64) {
		return 'style/t_64_64';
	}else if(size <= 120) {
		return 'style/t_120_120';
	}else if(size <= 200) {
		return 'style/t_200_200';
	}else if(size <= 300) {
		return 'style/t_300_300';
	}else if(size <= 400) {
		return 'style/t_400_400';
	}else if(size <= 500) {
		return 'style/t_500_500';
	}else if(size <= 600) {
		return 'style/t_600_600';
	}else if(size <= 700) {
		return 'style/t_700_700';
	}else if(size <= 800) {
		return 'style/t_800_800';
	}else if(size <= 1000) {
		return 'style/t_1000_1000';
	}else if(size <= 2000) {
		return 'style/t_2000_2000';
	}
}